<template>
  <header
    id="trek-header"
    qaid="nav-app"
    :class="['nav-app', 'masthead', {'nav-app--is-electra': isElectraBrand, 'nav-app--is-trek': !isElectraBrand}]"
    data-sticky-container
  >
    <div
      :id="isB2b ? 'js-sticky-header' : null"
      data-sticky
      data-sticky-on="small"
      data-options="marginTop:0;"
      data-top-anchor="1"
      style="width:100%"
    >
      <div id="search" class="exitStageTop">
        <slot name="search" />
      </div>
      <a id="preNav"></a>

      <!--  
        Phase 2: Unify the implementation for b2b and b2c
        Because b2b's header uses an inline-template, moving this markup into NavApp.vue
        requires a significant refactor. Let's save this for phase 2 when we address the functionality,
        html, css & etc. For now, I've used a slot.
      -->
      <template v-if="isB2b">
        <slot name="b2b" />
      </template>

      <section v-else class="header-wrap" :class="isMultiBrand ? 'header-wrap--multibrand' : null">
        <slot name="compact-container" />
        <slot name="navigation" />
        <slot name="minicart" />
      </section>

      <nav-overlay-large-layout />
    </div>
  </header>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import viewSize from '@/mixins/view-size';
import NavOverlayLargeLayout from '@/navigation/layouts/NavOverlayLargeLayout.vue';

export default {
  /**
   * TODO: Setting global viewport states should happen at the root level, not the nav level.
   * However, at this time the root level is split between shell-base and vueConfig so there
   * is no singular root level element to do this in. Since the nav will be global, it makes
   * sense to do this here for now.
   * */
  name: 'NavApp',
  components: {
    NavOverlayLargeLayout,
  },
  mixins: [viewSize],
  props: {
    canShowCart: {
      type: Boolean,
      default: false,
    },
    isB2b: {
      type: Boolean,
      default: false,
    },
    isMultiBrand: {
      type: Boolean,
      default: false,
    },
    isElectraBrand: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
  },
  watch: {
    viewBreakpoint(val) {
      this.updateViewportState(val);
    },
    isCompactView() {
      this.unsetNav();
    },
  },
  mounted() {
    if (!this.isB2b) {
      this.hideFcpNav();
    }
    this.setHeaderHeight(document.getElementById('trek-header').offsetHeight);
  },
  methods: {
    ...mapActions('global', ['updateViewportState']),
    ...mapActions('navigation', ['unsetNav']),
    ...mapMutations('global', ['setHeaderHeight']),
    hideFcpNav() {
      document.getElementById('nav-app-fcp').className += 'is-finished';
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-app {
  &--is-trek {
    --nav-highlight-color: var(--red-100);
  }
  &--is-electra {
    --nav-highlight-color: var(--teal-100);
  }
}
</style>

<style>
#nav-app-fcp.is-finished {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  border: 0;
}
</style>
